'use strict';

var FilterCabinGridFilterFactory = function FilterCabinGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLevelFilterFactory', 'FlightLegFilterFactory', 'FlightCabinFilterFactory', 'FlightDOWFilterFactory', 'FlightSeasonFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FilterCabinGridFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], ['cabin-flight-da-analysis', 'cabin-flight-analysis', 'cabin-flight-analysis-post-departure']);
    this.registerFilters(injectedFilters);
  }
  FilterCabinGridFilter.constructor = FilterCabinGridFilter;
  FilterCabinGridFilter.prototype = Object.create(DemandFilter.prototype);
  FilterCabinGridFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return FilterCabinGridFilter;
};
FilterCabinGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FilterCabinGridFilterFactory;